import React from 'react';

const RenderSharedSocialIcons = (item) => {
  const imageToReturn = [];
  if (item.instagramUrl) {
    imageToReturn.push(
      <a className="social-icon instagram" href={item.instagramUrl} target="_blank" rel="noopener noreferrer" />,
    );
  }
  if (item.facebookUrl) {
    imageToReturn.push(
      <a className="social-icon facebook" href={item.facebookUrl} target="_blank" rel="noopener noreferrer" />,
    );
  }
  if (item.twitterUrl) {
    imageToReturn.push(
      <a className="social-icon twitter" href={item.twitterUrl} target="_blank" rel="noopener noreferrer" />,
    );
  }
  if (item.youtubeUrl) {
    imageToReturn.push(
      <a className="social-icon youtube" href={item.youtubeUrl} target="_blank" rel="noopener noreferrer" />,
    );
  }
  if (item.spotifyUrl) {
    imageToReturn.push(
      <a className="social-icon spotify" href={item.spotifyUrl} target="_blank" rel="noopener noreferrer" />,
    );
  }
  return imageToReturn;
};

export default RenderSharedSocialIcons;
